import store from '@/store';
import {Module, getModule, Action, Mutation} from 'vuex-module-decorators';
import {DiagramModule} from '@/store/modules/diagramModule';
import {
  WaterfallSettings,
  WaterfallDiagramDataBeforeZoom,
} from '@/components/services/vibrationDiagnostic/interfaces';
import {SpectrumEventType, SpectrumYAxisType} from '@/enums/diagrams';
import {DtcpAccelerometerStoreModule} from './entities/pmodules/dtcp/dtcpAccelerometerStoreModule';

/*
    Динамический модуль хранилища vuex для работы с состояниями диаграмм
*/

const moduleName = 'waterfallDiagramModule';

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
class WaterfallDiagramModule extends DiagramModule {
  taskCode = '';

  get getTaskCode() {
    return this.taskCode;
  }

  @Mutation
  setTaskCodeMutation() {
    const value = window.localStorage.getItem('waterfallSettings');
    if (value) this.taskCode = JSON.parse(value).taskCode;
  }

  @Mutation
  saveWaterfallSettingsMutation(settings: WaterfallSettings) {
    window.localStorage.setItem('waterfallSettings', JSON.stringify(settings));
  }

  @Mutation
  setDataBeforeZoomMutation(data: WaterfallDiagramDataBeforeZoom) {
    window.localStorage.setItem('waterfallDataBeforeZoom', JSON.stringify(data));
  }

  @Action
  init() {
    this.context.commit('setTaskCodeMutation');
  }

  @Action
  getWaterfallSettings(): WaterfallSettings | null {
    const value = window.localStorage.getItem('waterfallSettings');
    if (value) return JSON.parse(value);
    else return null;
  }

  @Action
  saveWaterfallSettings(settings: WaterfallSettings) {
    this.context.commit('saveWaterfallSettingsMutation', settings);
  }

  //OK
  @Action
  async start(params: {settings: WaterfallSettings; store: DtcpAccelerometerStoreModule}) {
    try {
      if (
        !params.settings.currentDateTimeInterval.startDateTime ||
        !params.settings.currentDateTimeInterval.endDateTime
      )
        return false;

      //Получаем this.pmoduleModule

      const response: any = await params.store.runIntervalSpectrumTask({
        id: params.settings.accelerometerModuleId,
        startDate: params.settings.currentDateTimeInterval.startDateTime,
        endDate: params.settings.currentDateTimeInterval.endDateTime,
        spectrumType: params.settings.spectrumType,
        aggregateType: params.settings.aggregateType,
        heightToKeep: params.settings.heightToKeep,
        widthToKeep: params.settings.widthToKeep,
        offset: params.settings.offset > 0 ? params.settings.offset : undefined,
        length: params.settings.length ? params.settings.length : undefined,
        thiningFactor: params.settings.thiningFactor ? params.settings.thiningFactor : undefined,
        parallelFactor: params.settings.parallelFactor,
        axisType: params.settings.axisType,
      });
      if (response.status === 200 && response.data) {
        params.settings.taskCode = response.data;
        this.saveWaterfallSettings(params.settings);
        this.context.commit('setTaskCodeMutation');
      }
      return false;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //OK?
  @Action
  async getStatus() {
    const value = window.localStorage.getItem('waterfallSettings');
    if (value) return JSON.parse(value);
    else return null;
  }

  //OK
  @Action
  async stop(params: {
    accelerometerModuleId: number;
    taskCode: string;
    store: DtcpAccelerometerStoreModule;
  }) {
    try {
      const response: any = await params.store.stopIntervalSpectrumTask({
        id: params.accelerometerModuleId,
        taskCode: params.taskCode,
      });

      if (response.status === 200 && response.data) {
        if (response.data === true) this.clearSettings();
        else return response.data;
      }
    } catch (e) {
      return Promise.reject(e);
    }
  }

  @Action
  clearSettings() {
    window.localStorage.removeItem('waterfallSettings');
  }

  //OK
  @Action
  async getResult(data: {
    accelerometerId: number;
    taskCode: string;
    axisType: SpectrumYAxisType;
    spectrumEventType: SpectrumEventType;
    store: DtcpAccelerometerStoreModule;
  }): Promise<any[]> {
    try {
      const response: any = await data.store.getIntervalSpectrumTaskResult({
        id: data.accelerometerId,
        taskCode: data.taskCode,
        axisType: data.axisType,
        spectrumEventType: data.spectrumEventType,
      });

      if (response.status === 200) {
        return response.data;
      }
      return [];
    } catch (e) {
      return Promise.reject(e);
    }
  }

  @Action
  async getDataBeforeZoom() {
    const value = window.localStorage.getItem('waterfallDataBeforeZoom');
    if (value) return JSON.parse(value);
    else return null;
  }

  @Action
  setDataBeforeZoom(data: WaterfallDiagramDataBeforeZoom) {
    this.context.commit('setDataBeforeZoomMutation', data);
  }

  @Action
  clearDataBeforeZoom() {
    window.localStorage.removeItem('waterfallDataBeforeZoom');
  }
}

export default getModule(WaterfallDiagramModule);
